import React from 'react';
import goatHero from 'assets/photos/goat.jpg';
import 'sections/styles/HeroSection.css';
import Button from 'components/controls/Button/Button';

const HeroSection: React.FC = () => {
	return (
		<section id="home" className="hero-section">
			<div className="hero-container">
				<div className="hero-content">
					{/* <span className="hero-badge">Eco-Friendly Land Clearing</span> */}
					<h1 className="hero-title">
						Looking for sustainable land clearing in East Tennessee? <br/>
						<span className="hero-highlight">Our herd's got you covered.</span>
					</h1>
					<p className="hero-subtitle">
						We use our goats to clear brush, weeds, and overgrowth—no chemicals, no machines, just nature doing its thing.
					</p>
					<div className="hero-actions">
						<Button to="/contact" variant="primary" size="lg">
							Get an Estimate
						</Button>
						{/* <Button to="/services" variant="outline" size="lg">
							Our Services
						</Button> */}
					</div>
				</div>
				<div className="hero-image-wrapper">
					<img src={goatHero} alt="A goat grazing in a field" className="hero-image" />
					<div className="hero-image-decorator"></div>
				</div>
			</div>
		</section>
	);
};

export default HeroSection;
